import React, { useState } from "react";
import BootstrapSlider from "./BootstrapSlider";

const slides = [
  {
    url: "/Linkedin/bill1.png",
    tip:
      "Move your mouse over different parts of the image to get instructions about that specific section",
  },
  {
    url: "/Linkedin/bill2.png",
    tip: "Tip: Make sure you leave an email that you check regularly",
  },
  {
    url: "/Linkedin/bill3.png",
    tip:
      "Link all your social media and portfolios you want companies and recruiters to be able to see (LinkedIn, Facebook, Stack Overflow, GitHub, your personal website etc.)",
  },
  {
    url: "/Linkedin/bill4.png",
    tip:
      "Be realistic when choosing the reason why you have a portfolio on Laika. This will help recruiters know whether you are suitable for the position on the long run.",
  },
];

function Linkedin(props) {
  return (
    <div className="container-fluid">
      <div
        className="Linkedin"
        style={{ backgroundImage: "url(/images/background.png)" }}
      >
        <div className="row mx-0">
          <div className="col bg-white">
            <div className="row">
              <div className="col-md-10 offset-md-1 setHeight">
                <div>
                  <BootstrapSlider
                    slides={slides}
                    handleHover={props.handleHover}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Linkedin;
